<template>
  <div class="liu pos-manage">
    <mt-header fixed title="商户认证" class="title1" />
    <!-- 主页面 -->
    <div class="scroll-container" :style="customScrollHeight">
      <!-- 活体 -->
      <div v-show="flow.step===1">
        <div class="form mt-15">
          <!-- 标题 -->
          <div class="title">
            <span>{{ living.facePicture.label }}</span>
          </div>
          <!-- 正文 -->
          <div class="row">
            <div class="item">
              <div class="content">
                <div class="living" style="width:50%;" @click="onTakeFacePictureClick">
                  <svg-icon v-if="!living.facePicture.value" icon-class="camera_comm" class-name="svg" />
                  <img v-else :src="living.facePicture.value" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn">
          <mt-button type="primary" size="large" @click="onTakeFacePictureClick">开始人脸识别</mt-button>
        </div>
      </div>
      <!-- 手持 -->
      <div v-show="flow.step===2">
        <div class="form mt-15">
          <!-- 标题 -->
          <div class="title">
            <span>{{hold.idCardPicture.label }}</span>
          </div>
          <!-- 正文 -->
          <div class="row">
            <div class="item">
              <div class="content">
                <div class="living" style="width:80%;">
                  <img v-if="!hold.idCardPicture.value" :src="require('@/assets/handheld_example@3x.png')" alt="" />
                  <img v-else :src="hold.idCardPicture.value" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn">
          <mt-button v-show="hold.step===1" type="primary" size="large" @click="onTakeHoldPictureClick">拍摄手持照片</mt-button>
          <mt-button v-show="hold.step===2" type="default" size="large" @click="onTakeHoldPictureClick">重新拍照</mt-button>
          <mt-button v-show="hold.step===2" type="primary" size="large" @click="onHoldPictureSubmitClick">上传手持照片</mt-button>
        </div>
      </div>
      <!-- 提示 -->
      <div v-show="flow.step===3">
        <div class="big-picture">
          <svg-icon icon-class="business_success" class-name="svg" />
          <span v-html="finished.msg" />
        </div>
      </div>
    </div>
    <!-- 人脸识别（视频） -->
    <mt-popup class="liveness-popup" v-model="living.popVisible" :closeOnClickModal="false">
      <xwp-video-liveness ref="videoLiveness" @openImageLiveness="xwpOpenImgLiveness"></xwp-video-liveness>
    </mt-popup>
    <!-- 人脸识别（图片） -->
    <xwp-image-liveness ref="imageLiveness" @getImgInfo="getImgLivenessImgInfo"></xwp-image-liveness>
    <!-- 相机组件 -->
    <camera ref="camera" @getImgInfo="getCameraImgInfo" />
  </div>
</template>

<script>
/* exported PUBLIC_TOKEN */
/* global  PUBLIC_TOKEN */
/* global PUBLIC_FACEVERIFY_TYPE */

import { GetTokenByDls } from '@/api/interface';
import { GetOcrToken, UpdateFaceDetectionData } from '@/api/customer';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { upLoadImgForAgent } from '@/utils/utils';
import { CusToast, CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { mapGetters, mapMutations } from 'vuex';
import XwpVideoLiveness from '@/components/XwpVideoLiveness';
import XwpImageLiveness from '@/components/XwpImageLiveness';
import SvgIcon from '@/components/SvgIcon';
import camera from '@/components/camera';

export default {
  name: 'PosManageLivingBody',
  components: { SvgIcon, camera, XwpVideoLiveness, XwpImageLiveness },
  data() {
    return {
      flow: {
        step: 1,
      },
      living: {
        faceType: PUBLIC_FACEVERIFY_TYPE,
        facePicture: { label: '人脸识别', value: '', placeholder: '' },
        popVisible: false,
      },
      hold: {
        idCardPicture: { label: '手持身份证照片', value: '', placeholder: '' },
        step: 1,
      },
      finished: {
        msg: '',
      },
    };
  },
  computed: {
    ...mapGetters(['livingFaceImgUrl', 'livingFacePopupStatus', 'livingFaceType']),
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  watch: {
    livingFacePopupStatus(val) {
      this.living.popVisible = val;
    },
    livingFaceImgUrl(val) {
      // 2022.5.23 新增人脸活体出错转人工
      if (val === 'living face error') {
        CusAlert('活体检测不成功<br />请上传手持身份证照片等待人工审核', () => {
          this.living.facePicture.value = '';
          this.flow.step = 2;
          this.hold.step = 1;
        });
      } else {
        CusLoadingOpen();
        const data = {
          _id: this.$route.query.id,
          facePicUrl: val,
          idCardHolderPicUrl: '',
          faceDetectionType: this.livingFaceType,
        };
        UpdateFaceDetectionData(data)
          .then(res => {
            CusLoadingClose();
            SucceedHandle2(
              res.code,
              res.msg,
              () => {
                this.flow.step = 3;
                if (res.innerCode === 1000) {
                  this.finished.msg = '当前信息提交成功<br />协议已生成，请您及时签署以完成此入驻流程';
                } else if (res.innerCode === 1001) {
                  this.finished.msg = '当前信息提交成功<br />';
                } else if (res.innerCode === 1002) {
                  this.finished.msg = '当前信息提交成功<br />请耐心等待后台人员审核';
                } else {
                  this.finished.msg = '';
                }
              },
              (code, msg) => {
                if (code === 1098) {
                  CusAlert(msg, () => {
                    this.living.facePicture.value = val;
                    this.flow.step = 2;
                    this.hold.step = 1;
                  });
                } else {
                  msg && CusToast(msg);
                }
              }
            );
          })
          .catch(err => {
            CusLoadingClose();
            const msg = NotSucceedHandle(err.message);
            msg && CusToast(msg);
          });
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.flow.step = 1;
      this.hold.step = 1;
      this.setLivingFaceCustomerId(this.$route.query.id);
      this.getToken();
    });
  },
  methods: {
    ...mapMutations(['setLivingFaceAccessToken', 'setLivingFaceCustomerId', 'setLivingFacePopupStatus', 'setLivingFaceVerifyType']),
    // 调用接口，获得token （代理商使用）
    getToken(callback = null) {
      GetTokenByDls()
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              PUBLIC_TOKEN = res.data.token;
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取活体识别关键信息
    getOcrToken(callback = null) {
      CusLoadingOpen();
      GetOcrToken({ id: this.$route.query.id })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.setLivingFaceAccessToken(res.data.accessToken);
              callback && callback();
            },
            (code, msg) => {
              if (code === 1099) {
                this.flow.step = 3;
                this.finished.msg = msg;
              } else if (code === 1098) {
                CusAlert(`${msg}<br />请分别上传人脸照片和手持身份证照片`, () => this.$refs.imageLiveness.imgClick('onlyFacePicture'));
              } else {
                msg && CusToast(msg);
              }
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 跳人脸识别页面
    jumpToLiveness() {
      if (this.living.faceType === 1 || this.living.faceType === 2) {
        this.setLivingFacePopupStatus(true);
        this.setLivingFaceVerifyType(this.living.faceType);
        this.$refs.videoLiveness.drawBaiduSessionCode();
      }
      if (this.living.faceType === 3) {
        this.setLivingFaceVerifyType(this.living.faceType);
        this.$refs.imageLiveness.imgClick('faceverifyPicture');
      }
    },
    // 返回静默活体认证的图片信息
    getImgLivenessImgInfo(info) {
      upLoadImgForAgent(info.blob, info.base64, info.type, res => {
        if (info.type === 'faceverifyPicture') {
          this.$refs.imageLiveness.startBaiduV3Faceverify(res.data);
        }
        if (info.type === 'onlyFacePicture') {
          this.living.facePicture.value = res.data;
          this.flow.step = 2;
          this.hold.step = 1;
        }
      });
    },
    // 返回的图片信息
    getCameraImgInfo(info) {
      upLoadImgForAgent(info.blob, info.base64, info.type, res => {
        if (info.type === 'idCardPicture') {
          this.hold.idCardPicture.value = res.data;
          this.flow.step = 2;
          this.hold.step = 2;
        }
      });
    },
    // 打开静默人脸检测事件
    xwpOpenImgLiveness() {
      this.$refs.imageLiveness.imgClick('faceverifyPicture');
    },
    // 人脸拍照片事件
    onTakeFacePictureClick() {
      this.getOcrToken(() => {
        this.jumpToLiveness();
      });
    },
    // 手持拍照片事件
    onTakeHoldPictureClick() {
      this.$refs.camera.imgClick('idCardPicture');
    },
    // 手持上传照片事件
    onHoldPictureSubmitClick() {
      CusLoadingOpen();
      const data = {
        _id: this.$route.query.id,
        facePicUrl: this.living.facePicture.value,
        idCardHolderPicUrl: this.hold.idCardPicture.value,
        faceDetectionType: this.livingFaceType,
      };
      UpdateFaceDetectionData(data)
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.flow.step = 3;
              if (res.innerCode === 1000) {
                this.finished.msg = '当前信息提交成功<br />协议已生成，请您及时签署以完成此入驻流程';
              } else if (res.innerCode === 1001) {
                this.finished.msg = '当前信息提交成功<br />';
              } else if (res.innerCode === 1002) {
                this.finished.msg = '当前信息提交成功<br />请耐心等待后台人员审核';
              } else {
                this.finished.msg = '';
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  .row {
    .item {
      margin-right: 0.6rem;
      .content {
        padding-right: 0.55rem;
      }
    }
  }
}
</style>
